import { Component, OnInit } from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Inject} from "@angular/core";
import {DataService} from "../../../../services/data.service";

/**
 * Parameters for EditThresholdComponent
 */
export interface EditThresholdDialogData {
  transitTime: string;
  threshold: string;
  cronDescriptor: string;
}

@Component({
  selector: 'app-edit-threshold',
  templateUrl: './edit-threshold.component.html',
  styleUrls: ['./edit-threshold.component.scss'],
  animations: [
    trigger('dialog', [
      transition('void => *', [
        style({ transform: 'scale3d(.3, .3, .3)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))
      ])
    ])
  ]
})
export class EditThresholdComponent implements OnInit {

  threshold = this.data.threshold;
  help_messages: any = this.dataService.help_messages;

  constructor(
    public dataService: DataService,
    private dialogRef: MatDialogRef<EditThresholdComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditThresholdDialogData
  ) { }

  ngOnInit(): void {
  }

  onCancel(){
    this.dialogRef.close()
  }

  onSubmit(){
    this.dialogRef.close(this.threshold)
  }
}
